// extracted by mini-css-extract-plugin
export var checkbox = "_6h-0";
export var circle = "_6h-3";
export var horizontalContainer = "_6h-7";
export var sm = "_6h-5";
export var switch0 = "_6h-2";
export var switchDisabled = "_6h-8";
export var switchEnabled = "_6h-1";
export var textSwitchContainer = "_6h-9";
export var textSwitchOption = "_6h-a";
export var textSwitchOptionSelected = "_6h-b";
export var verticalContainer = "_6h-6";
export var xs = "_6h-4";